module.exports = __webpack_public_path__ + "img/ee514c8.svg";